module.exports = __webpack_public_path__ + "img/New-2.f9720744.png";